module.exports = __webpack_public_path__ + "img/total_payment.f766d71f.svg";